export default "__VITE_ASSET__d328f76e__"